<template>
  <header class="blog-header">
    <div class="header-content">
      <div class="logo" @click="goHome">
        <div class="logo-image-wrapper">
          <img src="../assets/gwLog.webp" alt="Logo"  class="logo-image"/>
          <div class="logo-subtitle">LASER TECH</div>
        </div>
        <h1>光惠激光技术博客</h1>
      </div>
      
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu">
        <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>

      <div class="header-right" :class="{ 'mobile-open': mobileMenuOpen }">
        <nav class="nav-menu">
          <el-menu mode="horizontal" active-class="active" :ellipsis="false">
            <el-menu-item index="/" @click="handleNavClick('/', '博客')">博客</el-menu-item>
            <el-menu-item index="/categories" @click="handleNavClick('/categories', '分类')">分类</el-menu-item>
            <el-menu-item index="/tags" @click="handleNavClick('/tags', '标签')">标签</el-menu-item>
          </el-menu>
        </nav>
        <div class="search-box">
          <div class="search-wrapper">
            <i class="el-icon-search search-icon" @click="handleSearch"></i>
            <input 
              v-model="searchKeyword" 
              type="text"
              placeholder="搜索文章..." 
              class="search-input-custom"
              @keyup.enter="handleSearch"
            />
            <i v-if="searchKeyword" class="el-icon-circle-close clear-icon" @click="clearSearch"></i>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'BlogHeader',
  props: {
    initialKeyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchKeyword: '',
      mobileMenuOpen: false,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200
    }
  },
  mounted() {
    if (this.initialKeyword) {
      this.searchKeyword = this.initialKeyword
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    initialKeyword: {
      immediate: true,
      handler(val) {
        if (val) {
          this.searchKeyword = val
        }
      }
    },
    $route() {
      this.mobileMenuOpen = false
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth > 992 && this.mobileMenuOpen) {
        this.mobileMenuOpen = false
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    goHome() {
      if (this.searchKeyword) {
        this.searchKeyword = ''
        this.handleSearch()
      } else {
        this.$router.push('/').catch(() => {})
      }
    },
    goCategories() {
      this.$router.push('/categories').catch(() => {})
    },
    goTags() {
      this.$router.push('/tags').catch(() => {})
    },
    handleNavClick(path) {
      if (path === '/') {
        this.searchKeyword = ''
        this.$emit('search', '')
        setTimeout(() => {
          this.$router.push(path).catch(() => {})
        }, 50)
      } else {
        this.$router.push(path).catch(() => {})
      }
      if (this.windowWidth <= 992) {
        this.mobileMenuOpen = false
      }
    },
    handleSearch() {
      this.$emit('search', this.searchKeyword)
      if (this.windowWidth <= 992) {
        this.mobileMenuOpen = false
      }
    },
    clearSearch() {
      this.searchKeyword = ''
      this.handleSearch()
    }
  }
}
</script>

<style scoped>
.blog-header {
  background: #0b193f !important;
  padding: 0.75rem 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  position: relative;
}

/* Logo 区域 */
.logo {
  flex-shrink: 0;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
}

.logo:hover {
  transform: scale(1.02);
}
.logo-image{
    width: 50px;
    margin-right: 10px;
}

.logo h1 {
  color: white;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  letter-spacing: 1px;
}

.logo-subtitle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  font-size: 0.4rem;
  letter-spacing: 1px;
  text-align: center;
  background: rgba(11, 25, 63, 0.9);
  padding: 2px 0;
  width: 50px;
  text-align: center;
}

.logo-image-wrapper {
  position: relative;
  display: inline-block;
  line-height: 0;
}

/* 右侧区域（导航 + 搜索） */
.header-right {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
  justify-content: flex-end;
}

/* 导航菜单 */
.nav-menu {
  flex-shrink: 0;
}

.nav-menu .el-menu {
  background: transparent !important;
  border: none;
}

.nav-menu .el-menu-item {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 500;
  padding: 0 1.25rem;
  height: 48px;
  line-height: 48px;
  border-bottom: 2px solid transparent;
}

.nav-menu .el-menu-item:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-bottom-color: rgba(255, 255, 255, 0.5);
}

.nav-menu .el-menu-item.is-active {
  color: white;
  background: transparent;
  border-bottom-color: white;
}

/* ========== 全新搜索框样式 ========== */
.search-box {
  flex-shrink: 0;
}

.search-wrapper {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 40px;
  padding: 0 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
}

.search-wrapper:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.35);
}

.search-wrapper:focus-within {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.15);
}

.search-icon {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  margin-right: 10px;
  transition: color 0.2s ease;
}

.search-wrapper:focus-within .search-icon {
  color: white;
}

.search-input-custom {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 14px;
  padding: 10px 0;
  min-width: 200px;
}

.search-input-custom::placeholder {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
}

.search-input-custom:focus {
  outline: none;
}

.clear-icon {
 color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  width: 16px;  /* 固定宽度 */
  text-align: center;
}

.clear-icon:hover {
  color: white;
  transform: scale(1.1);
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  cursor: pointer;
  color: white;
  font-size: 24px;
  padding: 8px;
  transition: all 0.3s ease;
  z-index: 100;
}

.mobile-menu-btn:hover {
  transform: scale(1.1);
}

/* ========== 响应式布局 ========== */

/* 中等屏幕 */
@media (max-width: 1200px) {
  .header-content {
    padding: 0 1.2rem;
  }
  
  .logo h1 {
    font-size: 1.4rem;
  }
  
  .nav-menu .el-menu-item {
    padding: 0 1rem;
  }
  
  .search-input-custom {
    min-width: 160px;
  }
}

/* 平板设备 */
@media (max-width: 992px) {
  .blog-header {
    padding: 0.5rem 0;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .header-right {
    position: fixed;
    top: 0;
    right: -100%;
    width: 280px;
    height: 100vh;
    background: #0b193f;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 70px 20px 20px;
    gap: 1.5rem;
    transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
    z-index: 99;
  }
  
  .header-right.mobile-open {
    right: 0;
  }
  
  .nav-menu {
    width: 100%;
  }
  
  .nav-menu .el-menu {
    flex-direction: column;
    background: transparent;
  }
  
  .nav-menu .el-menu-item {
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
    margin: 4px 0;
    border-radius: 12px;
    border-bottom: none;
  }
  
  .nav-menu .el-menu-item:hover {
    background: rgba(255, 255, 255, 0.15);
    border-bottom-color: transparent;
  }
  
  .nav-menu .el-menu-item.is-active {
    background: rgba(255, 255, 255, 0.2);
    border-bottom-color: transparent;
  }
  
  .search-box {
    width: 100%;
  }
  
  .search-wrapper {
    width: 100%;
  }
  
  .search-input-custom {
    min-width: auto;
    width: 100%;
  }
  
  .header-right.mobile-open::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 280px;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
}

/* 手机设备 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 1rem;
  }
  .logo-image{
    width: 35px;
    margin-right: 10px;
}
  .logo h1 {
    font-size: 1.2rem;
    white-space: normal;
    line-height: 1.3;
  }
  
  .mobile-menu-btn {
    font-size: 22px;
  }
  
  .header-right {
    width: 260px;
  }
  
  .nav-menu .el-menu-item {
    height: 44px;
    line-height: 44px;
    font-size: 0.95rem;
  }
  
  .search-wrapper {
    padding: 0 14px;
  }
  
  .search-icon {
    font-size: 16px;
  }
  
  .search-input-custom {
    font-size: 13px;
    padding: 8px 0;
  }
  
  .search-input-custom::placeholder {
    font-size: 12px;
  }
}

/* 小屏手机 */
@media (max-width: 480px) {
  .blog-header {
    padding: 0.4rem 0;
  }
  
  .logo h1 {
    font-size: 1rem;
  }
  
  .logo-subtitle {
    display: none;
  }
  
  .mobile-menu-btn {
    font-size: 20px;
    padding: 6px;
  }
  
  .header-right {
    width: 240px;
    padding: 60px 16px 16px;
  }
  
  .nav-menu .el-menu-item {
    height: 40px;
    line-height: 40px;
    font-size: 0.9rem;
    padding: 0 12px;
  }
  
  .search-wrapper {
    padding: 0 12px;
  }
  
  .search-icon {
    font-size: 14px;
    margin-right: 8px;
  }
  
  .search-input-custom {
    font-size: 12px;
  }
}

/* 超大屏幕优化 */
@media (min-width: 1920px) {
  .header-content {
    max-width: 1200px;
  }
  
  .logo h1 {
    font-size: 1.8rem;
  }
  
  .nav-menu .el-menu-item {
    font-size: 1.1rem;
    padding: 0 1.5rem;
  }
  
  .search-wrapper {
    min-width: 280px;
  }
  
  .search-input-custom {
    min-width: 200px;
  }
}

/* 辅助类 */
@media (max-width: 992px) {
  .header-right {
    backdrop-filter: blur(10px);
  }
}
</style>